import { jsPDF } from 'jspdf';

import InterBold from './fonts/Inter-SemiBold.ttf';
import { IGenerateQRForPrintArgs } from './interfaces';

export const generateQRForPrint = ({
  t,
  lang,
  qrLink,
  title,
  group,
}: IGenerateQRForPrintArgs): void => {
  const doc = new jsPDF({
    orientation: 'portrait',
    unit: 'px',
    format: [344, 496],
  });

  // Регистрируем шрифт Inter
  doc.setLanguage(lang === 'uz' ? 'en' : lang);
  doc.addFont(InterBold, 'InterBold', 'normal');
  doc.setTextColor('#0D1217');
  doc.setFont('InterBold');
  doc.setFontSize(24);
  doc.text(
    `${t('modal.generate_qr.title', title as string, group as string)}`,
    doc.internal.pageSize.getWidth() / 2,
    44,
    {
      align: 'center',
    }
  );

  doc.text(
    t('print_qr.description'),
    doc.internal.pageSize.getWidth() / 2,
    380,
    {
      align: 'center',
    }
  );
  doc.addImage(qrLink, 'PNG', 32, 72, 278, 278);

  const pdfBlob = doc.output('bloburi');

  open(pdfBlob);
};
